import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import { validate as uuidValidate } from 'uuid';
import classNames from 'classnames/bind';
import GeckoFeatures from 'services/gecko-features';
import Filter from '../Filter.jsx';
import { CONSTS } from 'constants/index.js';
import CustomFilterDropdown from './components/CustomFilterDropdown';
import PinnedSavedCustomFilters from './components/PinnedSavedCustomFilters';

const ConversationFilters = (props) => {
  const {
    conversationLengths,
    currentFilter,
    hasNotification,
    onFilterSelect,
    restrictedConversationsView,
  } = props;
  const [filterDropDownOpen, setFilterDropDownOpen] = useState(false);

  const getFilterCountLabel = (conversationFilter) => {
    const filterCount = conversationLengths[conversationFilter];
    return filterCount ? `(${filterCount})` : '';
  };

  const haveUndeliveredConversations =
    conversationLengths[CONSTS.FILTER_UNDELIVERED] > 0;
  const isOnUndeliveredFilter = currentFilter === CONSTS.FILTER_UNDELIVERED;
  const shouldShowUndeliveredFilter =
    (haveUndeliveredConversations || isOnUndeliveredFilter) &&
    GeckoFeatures.can('undelivered-filter');

  const filterIsNotInDropdown =
    currentFilter === CONSTS.FILTER_CUSTOM_FILTER ||
    uuidValidate(currentFilter);
  const dropdownLabel = filterIsNotInDropdown
    ? CONSTS.FILTER_MY_CONVERSATIONS
    : currentFilter;
  const dropdownLabelCount = filterIsNotInDropdown
    ? getFilterCountLabel(CONSTS.FILTER_MY_CONVERSATIONS)
    : getFilterCountLabel(currentFilter);
  return (
    <>
      <div className="d-block d-sm-inline-block d-xl-none">
        <Dropdown
          className="QuickFiltersDropdown Filter float-right float-sm-left float-md-left"
          show={filterDropDownOpen}
          onToggle={() => setFilterDropDownOpen(!filterDropDownOpen)}
          drop="down"
        >
          <Dropdown.Toggle
            as="button"
            className={`gecko-btn gecko-ui-material btn btn-default ${
              shouldShowUndeliveredFilter ? 'error' : ''
            }`}
            caret
          >
            {`${dropdownLabel} ${dropdownLabelCount}`}
          </Dropdown.Toggle>

          <Dropdown.Menu className="gecko-dropdown-menu">
            <div className="QuickFiltersDropdown__menu-container">
              <Dropdown.Item
                className="QuickFiltersDropdown__menu-item"
                onClick={() => onFilterSelect(CONSTS.FILTER_MY_CONVERSATIONS)}
              >
                <div
                  className={classNames(
                    'QuickFilterDropdown__menu-item-label',
                    {
                      'unread-indicator':
                        hasNotification[CONSTS.FILTER_MY_CONVERSATIONS],
                    }
                  )}
                >
                  {CONSTS.FILTER_MY_CONVERSATIONS}{' '}
                  {getFilterCountLabel(CONSTS.FILTER_MY_CONVERSATIONS)}
                </div>
                {currentFilter === CONSTS.FILTER_MY_CONVERSATIONS ? (
                  <div>
                    <i className="far fa-check" />
                  </div>
                ) : null}
              </Dropdown.Item>

              {!restrictedConversationsView ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item "
                  onClick={() => onFilterSelect(CONSTS.FILTER_UNASSIGNED)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator':
                          hasNotification[CONSTS.FILTER_UNASSIGNED],
                      }
                    )}
                  >
                    {CONSTS.FILTER_UNASSIGNED}{' '}
                    {getFilterCountLabel(CONSTS.FILTER_UNASSIGNED)}
                  </div>
                  {currentFilter === CONSTS.FILTER_UNASSIGNED ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}

              {!restrictedConversationsView ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item"
                  onClick={() => onFilterSelect(CONSTS.FILTER_OPEN)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator': hasNotification[CONSTS.FILTER_OPEN],
                      }
                    )}
                  >
                    {CONSTS.FILTER_OPEN}{' '}
                    {getFilterCountLabel(CONSTS.FILTER_OPEN)}
                  </div>
                  {currentFilter === CONSTS.FILTER_OPEN ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}

              <Dropdown.Item
                className="QuickFiltersDropdown__menu-item"
                onClick={() => onFilterSelect(CONSTS.FILTER_CLOSED)}
              >
                <div
                  className={classNames(
                    'QuickFilterDropdown__menu-item-label',
                    {
                      'unread-indicator': hasNotification[CONSTS.FILTER_CLOSED],
                    }
                  )}
                >
                  {CONSTS.FILTER_CLOSED}{' '}
                  {getFilterCountLabel(CONSTS.FILTER_CLOSED)}
                </div>
                {currentFilter === CONSTS.FILTER_CLOSED ? (
                  <div>
                    <i className="far fa-check" />
                  </div>
                ) : null}
              </Dropdown.Item>

              <Dropdown.Item
                className="QuickFiltersDropdown__menu-item"
                onClick={() => onFilterSelect(CONSTS.FILTER_SENT)}
              >
                <div
                  className={classNames(
                    'QuickFilterDropdown__menu-item-label',
                    {
                      'unread-indicator': hasNotification[CONSTS.FILTER_SENT],
                    }
                  )}
                >
                  {CONSTS.FILTER_SENT} {getFilterCountLabel(CONSTS.FILTER_SENT)}
                </div>
                {currentFilter === CONSTS.FILTER_SENT ? (
                  <div>
                    <i className="far fa-check" />
                  </div>
                ) : null}
              </Dropdown.Item>

              {GeckoFeatures.can('chat-bot') && !restrictedConversationsView ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item"
                  onClick={() => onFilterSelect(CONSTS.FILTER_ASSIGNED_TO_BOT)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator':
                          hasNotification[CONSTS.FILTER_ASSIGNED_TO_BOT],
                      }
                    )}
                  >
                    {CONSTS.FILTER_ASSIGNED_TO_BOT}{' '}
                    {getFilterCountLabel(CONSTS.FILTER_ASSIGNED_TO_BOT)}
                  </div>
                  {currentFilter === CONSTS.FILTER_ASSIGNED_TO_BOT ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}

              {currentFilter === CONSTS.FILTER_CONTACT_OPEN ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item"
                  onClick={() => onFilterSelect(CONSTS.FILTER_CONTACT_OPEN)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator':
                          hasNotification[CONSTS.FILTER_CONTACT_OPEN],
                      }
                    )}
                  >
                    {CONSTS.FILTER_CONTACT_OPEN}{' '}
                    {getFilterCountLabel(CONSTS.FILTER_CONTACT_OPEN)}
                  </div>
                  {currentFilter === CONSTS.FILTER_CONTACT_OPEN ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}

              {currentFilter === CONSTS.FILTER_CONTACT ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item"
                  onClick={() => onFilterSelect(CONSTS.FILTER_CONTACT)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator':
                          hasNotification[CONSTS.FILTER_CONTACT],
                      }
                    )}
                  >
                    {CONSTS.FILTER_CONTACT}{' '}
                    {getFilterCountLabel(CONSTS.FILTER_CONTACT)}
                  </div>
                  {currentFilter === CONSTS.FILTER_CONTACT ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}

              {currentFilter === CONSTS.FILTER_TAG ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item"
                  onClick={() => onFilterSelect(CONSTS.FILTER_TAG)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator': hasNotification[CONSTS.FILTER_TAG],
                      }
                    )}
                  >
                    {CONSTS.FILTER_TAG} {getFilterCountLabel(CONSTS.FILTER_TAG)}
                  </div>
                  {currentFilter === CONSTS.FILTER_TAG ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}

              {shouldShowUndeliveredFilter ? (
                <Dropdown.Item
                  className="QuickFiltersDropdown__menu-item error"
                  onClick={() => onFilterSelect(CONSTS.FILTER_UNDELIVERED)}
                >
                  <div
                    className={classNames(
                      'QuickFilterDropdown__menu-item-label',
                      {
                        'unread-indicator':
                          hasNotification[CONSTS.FILTER_UNDELIVERED],
                      }
                    )}
                  >
                    {CONSTS.FILTER_UNDELIVERED}{' '}
                    {getFilterCountLabel(CONSTS.FILTER_UNDELIVERED)}
                  </div>
                  {currentFilter === CONSTS.FILTER_UNDELIVERED ? (
                    <div>
                      <i className="far fa-check" />
                    </div>
                  ) : null}
                </Dropdown.Item>
              ) : null}
            </div>
          </Dropdown.Menu>
        </Dropdown>
        <CustomFilterDropdown {...props} />
        <PinnedSavedCustomFilters {...props} />
      </div>
      <div className="d-none d-xl-block" role="menubar">
        <Filter
          filter={CONSTS.FILTER_MY_CONVERSATIONS}
          isActive={currentFilter === CONSTS.FILTER_MY_CONVERSATIONS}
          hasUnreads={hasNotification[CONSTS.FILTER_MY_CONVERSATIONS]}
          length={conversationLengths[CONSTS.FILTER_MY_CONVERSATIONS]}
          onFilterSelected={onFilterSelect}
        />
        {!restrictedConversationsView ? (
          <Filter
            filter={CONSTS.FILTER_UNASSIGNED}
            isActive={currentFilter === CONSTS.FILTER_UNASSIGNED}
            hasUnreads={hasNotification[CONSTS.FILTER_UNASSIGNED]}
            length={conversationLengths[CONSTS.FILTER_UNASSIGNED]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
        {!restrictedConversationsView ? (
          <Filter
            filter={CONSTS.FILTER_OPEN}
            isActive={currentFilter === CONSTS.FILTER_OPEN}
            hasUnreads={hasNotification[CONSTS.FILTER_OPEN]}
            length={conversationLengths[CONSTS.FILTER_OPEN]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
        <Filter
          filter={CONSTS.FILTER_CLOSED}
          isActive={currentFilter === CONSTS.FILTER_CLOSED}
          hasUnreads={hasNotification[CONSTS.FILTER_CLOSED]}
          length={conversationLengths[CONSTS.FILTER_CLOSED]}
          onFilterSelected={onFilterSelect}
        />
        <Filter
          filter={CONSTS.FILTER_SENT}
          isActive={currentFilter === CONSTS.FILTER_SENT}
          hasUnreads={hasNotification[CONSTS.FILTER_SENT]}
          length={conversationLengths[CONSTS.FILTER_SENT]}
          onFilterSelected={onFilterSelect}
        />
        {GeckoFeatures.can('chat-bot') && !restrictedConversationsView ? (
          <Filter
            filter={CONSTS.FILTER_ASSIGNED_TO_BOT}
            isActive={currentFilter === CONSTS.FILTER_ASSIGNED_TO_BOT}
            hasUnreads={hasNotification[CONSTS.FILTER_ASSIGNED_TO_BOT]}
            length={conversationLengths[CONSTS.FILTER_ASSIGNED_TO_BOT]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
        {currentFilter === CONSTS.FILTER_CONTACT_OPEN ? (
          <Filter
            filter={CONSTS.FILTER_CONTACT_OPEN}
            isActive={true}
            hasUnreads={hasNotification[CONSTS.FILTER_CONTACT_OPEN]}
            length={conversationLengths[CONSTS.FILTER_CONTACT_OPEN]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
        {currentFilter === CONSTS.FILTER_CONTACT ? (
          <Filter
            filter={CONSTS.FILTER_CONTACT}
            isActive={true}
            hasUnreads={hasNotification[CONSTS.FILTER_CONTACT]}
            length={conversationLengths[CONSTS.FILTER_CONTACT]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
        {currentFilter === CONSTS.FILTER_TAG ? (
          <Filter
            filter={CONSTS.FILTER_TAG}
            isActive={true}
            hasUnreads={hasNotification[CONSTS.FILTER_TAG]}
            length={conversationLengths[CONSTS.FILTER_TAG]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
        <CustomFilterDropdown {...props} />
        <PinnedSavedCustomFilters {...props} />
        {shouldShowUndeliveredFilter ? (
          <Filter
            filter={CONSTS.FILTER_UNDELIVERED}
            isError={true}
            isActive={currentFilter === CONSTS.FILTER_UNDELIVERED}
            hasUnreads={hasNotification[CONSTS.FILTER_UNDELIVERED]}
            length={conversationLengths[CONSTS.FILTER_UNDELIVERED]}
            onFilterSelected={onFilterSelect}
          />
        ) : null}
      </div>
    </>
  );
};

export default ConversationFilters;
